export function register(config) {
    if ('serviceWorker' in navigator)
        navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`)
}
